import { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react';
import './ChoiceInput.css';

type NativeInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface ChoiceInputProps extends Omit<NativeInputProps, 'type'> {
    type: 'checkbox' | 'radio';
}

const indicatorByType = {
    checkbox: 'choice-input__indicator choice-input__indicator--checkbox',
    radio: 'choice-input__indicator choice-input__indicator--radio',
};

const markByType = {
    checkbox: <span className='choice-input__check' />,
    radio: <span className='choice-input__dot' />,
};

const ChoiceInput = forwardRef<HTMLInputElement, ChoiceInputProps>(function ChoiceInput(
    { className, type, disabled, ...props },
    ref,
) {
    return (
        <span className={'choice-input' + (className ? ` ${className}` : '')}>
            <input {...props} ref={ref} type={type} disabled={disabled} className='choice-input__native' />
            <span className={indicatorByType[type]} aria-hidden='true'>
                {markByType[type]}
            </span>
        </span>
    );
});

export default ChoiceInput;
